/*
 * -----------------------------------------------------------------------------------------
 * ErrorBoundary.tsx
 *
 * Copyright: (c) 2004-2022 Potthoff + Partner Unternehmensberatungs-Gesellschaft mbH
 *            All rights reserved.
 * -----------------------------------------------------------------------------------------
 * Erstellt : 17.05.2022
 * Autor    : Jonas Wessel
 *
 * Geändert : 28.11.2022
 *      von : Jonas Wessel
 * -----------------------------------------------------------------------------------------
 *
 * Changelog:
 *
 */

import React, {Component} from "react";
import {Button, Image} from "semantic-ui-react";

export class ErrorBoundary extends Component<{children: any}, { error: any, errorInfo: any }> {
    constructor(props) {
        super(props);
        this.state = { error: null, errorInfo: null };
        this.recover = this.recover.bind(this);
    }

    componentDidCatch(error, errorInfo) {
        console.error(error, errorInfo);
        this.setState({
        error: error,
        errorInfo: errorInfo
        });
    }

    recover() {
        setTimeout(() => {
        window.location.replace(window.location.origin + "/");
        window.location.reload();
        }, 1000);
        // }
    }

    render() {
        if (!this.state.errorInfo) {
            // Normally, just render children
            return this.props.children;
        }

        // Error path
        return (
            <>
                <div style={{ padding: "16px", paddingBottom: 0, display: "flex", justifyContent: "space-between" }}>
                    <Button negative basic onClick={() => this.recover()}>Seite aktualisieren</Button>
                </div>
                <div style={{ margin: "0 auto", padding: "16px", height: "calc(100% - 75px)" }}>
                    <div style={{ textAlign: "center", whiteSpace: "pre-wrap", overflow: "auto", height: "calc(80% - 5px)" }}>
                        {this.state.error && this.state.error.toString()}
                        <br />
                        {this.state.errorInfo.componentStack}
                    </div>
                </div>
            </>
        );
    }
}

export default ErrorBoundary;
